var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "send-web-notification-config" },
    [
      _c("div", { staticClass: "config-field" }, [
        _c("label", [
          _vm._v(_vm._s(_vm.$t("taskModuleRules.notificationMessage"))),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "input-with-variables" },
          [
            _c("a-textarea", {
              attrs: {
                placeholder: _vm.$t(
                  "taskModuleRules.notificationMessageWithDynamicVariables"
                ),
                rows: 3,
              },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.message,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "message", $$v)
                },
                expression: "localConfig.message",
              },
            }),
            _vm._v(" "),
            _c(
              "a-button",
              {
                attrs: { type: "link", size: "small" },
                on: {
                  click: function ($event) {
                    _vm.showVariablesPicker = true
                  },
                },
              },
              [
                _c("i", { staticClass: "material-icons" }, [_vm._v("code")]),
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("taskModuleRules.variables")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("small", [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$t("taskModuleRules.dynamicVariablesExample")) +
              "\n        "
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "config-field" },
        [
          _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.userType")))]),
          _vm._v(" "),
          _c(
            "a-radio-group",
            {
              attrs: { "button-style": "solid" },
              on: { change: _vm.emitChange },
              model: {
                value: _vm.localConfig.userType,
                callback: function ($$v) {
                  _vm.$set(_vm.localConfig, "userType", $$v)
                },
                expression: "localConfig.userType",
              },
            },
            [
              _c("a-radio-button", { attrs: { value: "static" } }, [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.staticUsers"))),
              ]),
              _vm._v(" "),
              _c("a-radio-button", { attrs: { value: "dynamic" } }, [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.dynamic"))),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.localConfig.userType === "static"
        ? _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [_vm._v(_vm._s(_vm.$t("taskModuleRules.users")))]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    mode: "multiple",
                    placeholder: _vm.$t("taskModuleRules.selectUsers"),
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.userStatic,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "userStatic", $$v)
                    },
                    expression: "localConfig.userStatic",
                  },
                },
                _vm._l(_vm.users, function (user) {
                  return _c(
                    "a-select-option",
                    { key: user._id, attrs: { value: user._id } },
                    [
                      _vm._v(
                        "\n                " +
                          _vm._s(user.name) +
                          "\n            "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.localConfig.userType === "dynamic"
        ? _c(
            "div",
            { staticClass: "config-field" },
            [
              _c("label", [
                _vm._v(_vm._s(_vm.$t("taskModuleRules.dynamicUsers"))),
              ]),
              _vm._v(" "),
              _c(
                "a-select",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    mode: "multiple",
                    placeholder: _vm.$t("taskModuleRules.selectDynamicUser"),
                  },
                  on: { change: _vm.emitChange },
                  model: {
                    value: _vm.localConfig.userDynamic,
                    callback: function ($$v) {
                      _vm.$set(_vm.localConfig, "userDynamic", $$v)
                    },
                    expression: "localConfig.userDynamic",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "task_owner" } }, [
                    _vm._v(_vm._s(_vm.$t("taskModuleRules.taskOwner"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_assignees" } },
                    [_vm._v(_vm._s(_vm.$t("taskModuleRules.taskAssignees")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_followers" } },
                    [_vm._v(_vm._s(_vm.$t("taskModuleRules.taskFollowers")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-select-option",
                    { attrs: { value: "task_collaborators" } },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("taskModuleRules.taskCollaborators"))
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showVariablesPicker
        ? _c("DynamicVariablesPicker", {
            attrs: { visible: _vm.showVariablesPicker },
            on: {
              close: function ($event) {
                _vm.showVariablesPicker = false
              },
              select: _vm.insertVariable,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }